// extracted by mini-css-extract-plugin
export var dropdown = "_ui-0";
export var imageWrapper = "_ui-3";
export var itemNameContainer = "_ui-1";
export var productImage = "_ui-2";
export var spinnerWrapper = "_ui-4";